import React, { PureComponent } from "react";

export default class MM extends PureComponent {
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="13"
        viewBox="0 0 512 341.326"
      >
        <g transform="translate(0 -85.337)">
          <rect
            width="512"
            height="341.326"
            transform="translate(0 85.337)"
            fill="#6da544"
          />
          <rect
            width="512"
            height="113.775"
            transform="translate(0 85.337)"
            fill="#ffda44"
          />
          <rect
            width="512"
            height="113.775"
            transform="translate(0 312.888)"
            fill="#d80027"
          />
          <path
            d="M384,227.261H286.217l-30.217-93-30.217,93H128l79.108,57.475-30.217,93L256,320.925l79.108,56.81-30.217-93Z"
            fill="#f0f0f0"
          />
        </g>
      </svg>
    );
  }
}
